import React, { useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import { storyblokEditable } from "gatsby-source-storyblok"
import { destinations } from "../utils/destinations"

const SearchTabsJp = ({ blok, hideBubble, destination, keyword, label, interest, duration }) => {
  // console.log(blok)
  // console.log(prefecture, season, typeOfTour, keyword)

  const [selectedDestination, setDestination] = useState(destination || '');
  const [selectedInterest, setInterest] = useState(interest || '');
  const [selectedDuration, setDuration] = useState(duration || '');


  const { destinationFilter, interestFilter } = useStaticQuery(graphql`
    query {
      destinationFilter: allStoryblokDatasourceEntry(filter: { data_source: { eq: "tour-destination-filter-ja" } }) {
        edges {
          node {
            id
            name
            value
            data_source
          }
        }
      },
      interestFilter: allStoryblokDatasourceEntry(filter: { data_source: { eq: "tour-interest-filter-ja" } }) {
        edges {
          node {
            id
            name
            value
            data_source
          }
        }
      }
    }
    `)
  // console.log(destinationFilter, interestFilter)

  let destinationGroup = [];
  destinationFilter.edges.forEach(({ node }) => {
    if (node.value == '-') {
      destinationGroup.push({
        label: node.name,
        destinations: []
      });
    }
    else if (destinationGroup.length > 0) {
      destinationGroup[destinationGroup.length - 1].destinations.push(node);
    }
  });
  // console.log(destinationGroup);

  return (
    <div className="container max-w-4xl mx-auto" {...storyblokEditable(blok)}>
      { !hideBubble &&
      <div className="m-4 text-center h-0 flex items-center justify-end">
        <a className="z-10" href="tel:800-929-2663"><img className="h-auto w-[240px]" loading="lazy" src="/img/ja-tel.png" alt="tel" /></a>
      </div>
      }

      <div className="mb-4 border-b border-gray-200">
        <ul className="flex -mb-px font-medium text-center">
          <li className="me-2">
            <button className="inline-block p-3 border-b-2 border-lime-300 rounded-t-lg" data-tabs-target="#tour" type="button" aria-controls="tour" aria-selected="false">
            ツアー検索
            </button>
          </li>
          {/* <li className="me-2">
            <button className="inline-block p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300" type="button" aria-controls="flight" aria-selected="false">
              Find Flights
            </button>
          </li>
          <li className="me-2">
            <button className="inline-block p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300" type="button" aria-controls="hotel" aria-selected="false">
              Book Hotels
            </button>
          </li>
          <li>
            <button className="inline-block p-4 border-b-2 rounded-t-lg hover:text-gray-600 hover:border-gray-300" type="button" aria-controls="car" aria-selected="false">
              Rent Cars
            </button>
          </li> */}
        </ul>
      </div>

      <div className="mb-6 px-5">
        <div className="" aria-labelledby="tour-tab">
          <form method="GET" action="/ja/tours" className="flex flex-col sm:flex-row justify-center gap-2">
            <div className="p-3 rounded-lg border border-gray-800 flex">
              <img className="mr-2 inline-block" src="/icons/search-section-pin.svg" alt="" />
              <select name="destination" className="outline-none w-full" defaultValue={destination} value={selectedDestination} onChange={e => setDestination(e.target.value)}>
                <option value="">目的地から探す</option>
                { destinationGroup.map((optGroup, i) => (
                  <optgroup key={i} label={optGroup?.label}>
                    { optGroup?.destinations.map((d) => (
                      <option key={d.value} value={d.value}>{d.name}</option>
                    ))}
                  </optgroup>
                ))}
              </select>
            </div>

            <div className="p-3 rounded-lg border border-gray-800 flex">
              <select name="duration" className="outline-none w-full" defaultValue={duration} value={selectedDuration} onChange={e => setDuration(e.target.value)}>
                <option value="">日数から探す</option>
                <option value="1">半日〜1日</option>
                <option value="2-4">2〜4日間</option>
                <option value="5-">5日間以上</option>
              </select>
            </div>

            <div className="p-3 rounded-lg border border-gray-800 flex">
              <img className="mr-2" src="/icons/tag.svg" alt="Tag icon"/>
              <select name="interest" className="outline-none w-full" defaultValue={interest} value={selectedInterest} onChange={e => setInterest(e.target.value)}>
                <option value="">キーワードから探す</option>
                { interestFilter.edges.map(({ node }) => (
                  <option key={node.value} value={node.value}>{node.name}</option>
                ))}
              </select>
            </div>

            
            {/* 
            <span className="self-center"> or </span>
            <div className="p-3 rounded-lg border border-gray-800">
              <input type="text" name="keyword" defaultValue={keyword} placeholder="キーワード" className="outline-none w-full" />
            </div> 
            */}

            <button type="submit" className="bg-gray-800 text-white rounded-lg p-2">
              <img className="h-8 w-full" src="/icons/search-section-cta.svg" alt="Search tours"/>
            </button>
          </form>
        </div>


        <div className="hidden p-4 rounded-lg" aria-labelledby="flight-tab">
          <p className="">

          </p>
        </div>
        <div className="hidden p-4 rounded-lg" aria-labelledby="hotel-tab">
          <p className="">
            
          </p>
        </div>
        <div className="hidden p-4 rounded-lg" aria-labelledby="car-tab">
          <p className="">
          </p>
        </div>
      </div>
    </div>
  )
};

export default SearchTabsJp;
